import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const NotificationHistoricActionsEmail = ({ notificationHistoric, t, handleClick = () => {} }) => (
  <Form.Button
    text={t('notification_historic.view_email')}
    color={notificationHistoric.active ? 'outline-warning' : 'outline-info'}
    extraClassName={'btn-sm'}
    isLoading={notificationHistoric.isLoading}
    onClick={(e) => {
      e.preventDefault();
      let wnd = window.open('about:blank', '', '_blank');
      wnd.document.write(notificationHistoric.description);
    }}
  />
);

export default translate()(NotificationHistoricActionsEmail);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/list/actions/NotificationsHistoricActionsEmail.js